export const InsertBlockPlayerSelect = {
  name: "player",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "insert.child.blockPlayer",
  showOn: [{ state: "editState", value: "insert-block-player", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  showDetails: { events: ["parent"] },
  children: [
    {
      name: "player-select",
      component: "PlayerSelect",
      layout: "player-select",
      mode: "visible",
      showOn: [true],
      options: {
        currentEntityEvent: "parent",
        currentEntity: false,
        showBench: false,
        showCoach: false,
        excludeOtherEvents: false,
        excludePlayer: true,
        excludeFrom: "parent",
      },
      actionGroups: [
        {
          actions: [
            { action: "newEventId", type: "main",  value: null,  },
            { action: "saveData", type: "eventType", value: "block",  },
            {
              action: "sendEvent",
              value: "edit",
              type: "main",
            },
            { action: "nextState", value: null, type: "editState" },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
